import { useState, useEffect, useContext } from 'react'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { APIContext } from 'context/APIContext'
import { ConvertCentimetersToInches, ConvertKilogramsToPounds } from 'functions/measurementSystemUtils'
import { ModalContext } from '../ModalContext'
import moment from 'moment'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function EditFitnessProfileModal() {

    const { modalData, HideModal } = useContext(ModalContext)
    const { RegenerateActiveProgramVolume, RegenerateActiveProgramIncompleteWorkouts } = useContext(APIContext)

    const profileType = modalData.profileType
    const groupId = modalData.groupId
    const userId = modalData.userId
    const boilerplateEnabled = modalData?.boilerplateEnabled || 0
    const clientDate = moment().format('YYYY-MM-DD')

    const [fitnessProfile, setFitnessProfile] = useState(modalData.fitnessProfile)
    const [defaultAverageHeightCentimeters, setDefaultAverageHeightCentimeters] = useState(0)
    const [defaultAverageWeightKilograms, setDefaultAverageWeightKilograms] = useState(0)
    const [heightCentimeters, setHeightCentimeters] = useState(0)
    const [weightKilograms, setWeightKilograms] = useState(0)
    const [sports, setSports] = useState(null)
    // const [sportKey, setSportKey] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [saveChangesLoading, setSaveChangesLoading] = useState(false)

    const GetSportsFromBackend = async () => {

        const result = await WhichWeightAPI('CORE', 'GET', '/sports')

        // console.log(result.data.data)

        if (result.data.status === 'failure') {
            console.error(result)
            return
        }

        setSports(result.data.data)

        // Supporting custom sport option case

        // var backendSportOptions = JSON.parse(JSON.stringify(result.data.data))

        // const passedFitnessProfileSportKey = ConvertSportIdAndNameToKey(fitnessProfile.sportId, fitnessProfile.sportName, backendSportOptions)

        // if (passedFitnessProfileSportKey === undefined) {
        //     const customOtherSportOption = {
        //         id: 15,
        //         name: fitnessProfile.sportName,
        //         key: 'custom-other'
        //     }

        //     backendSportOptions.push(customOtherSportOption)
        // }

        // // console.log(backendSportOptions)

        // setSports(backendSportOptions)

    }

    /*
    const ConvertSportIdAndNameToKey = (sportId, sportName, backendSportOptions) => {
        const backendSportOption = backendSportOptions.find(option => (
            parseInt(option.id) === parseInt(sportId) &&
            option.name === sportName
        ));

        if (backendSportOption === undefined) return undefined

        return backendSportOption.key
    }
    */

    const HandleFitnessProfileChange = (key, value) => {

        // console.log(key, value)

        var temp_fitnessProfile = JSON.parse(JSON.stringify(fitnessProfile))

        switch (key) {
            case 'defaultAverageAge':
                temp_fitnessProfile.defaultAverageAge = value
                break

            case 'defaultGender':
                temp_fitnessProfile.defaultGender = value
                break

            case 'defaultAverageHeightFeet':
                var current_inches = temp_fitnessProfile.defaultAverageHeight % 12
                temp_fitnessProfile.defaultAverageHeight = (value * 12) + current_inches
                break

            case 'defaultAverageHeightInches':
                var current_feet = Math.floor(temp_fitnessProfile.defaultAverageHeight / 12)
                temp_fitnessProfile.defaultAverageHeight = (current_feet * 12) + value
                break

            case 'defaultAverageHeightCentimeters':
                setDefaultAverageHeightCentimeters(value)
                temp_fitnessProfile.defaultAverageHeight = Math.round(ConvertCentimetersToInches(value))
                break

            case 'defaultAverageWeight':
                if (temp_fitnessProfile.measurementSystem === 'imperial') {
                    temp_fitnessProfile.defaultAverageWeight = parseInt(value)
                }

                if (temp_fitnessProfile.measurementSystem === 'metric') {
                    setDefaultAverageWeightKilograms(parseInt(value))
                    temp_fitnessProfile.defaultAverageWeight = Math.round(ConvertKilogramsToPounds(parseInt(value)))
                }

                break

            case 'birthday':
                temp_fitnessProfile.birthday = value
                break

            case 'gender':
                temp_fitnessProfile.gender = value
                break

            case 'measurement-system':
                temp_fitnessProfile.measurementSystem = value

                if (value === 'metric') {
                    setHeightCentimeters(0)
                    setWeightKilograms(0)
                    temp_fitnessProfile.height = 0
                    temp_fitnessProfile.weight = 0
                }

                break

            case 'height-feet':
                var current_inches = temp_fitnessProfile.height % 12
                temp_fitnessProfile.height = (value * 12) + current_inches
                break

            case 'height-inches':
                var current_feet = Math.floor(temp_fitnessProfile.height / 12)
                temp_fitnessProfile.height = (current_feet * 12) + value
                break

            case 'height-centimeters':
                setHeightCentimeters(value)
                temp_fitnessProfile.height = Math.round(ConvertCentimetersToInches(value))
                break

            case 'weight':
                if (temp_fitnessProfile.measurementSystem === 'imperial') {
                    temp_fitnessProfile.weight = parseInt(value)
                }

                if (temp_fitnessProfile.measurementSystem === 'metric') {
                    setWeightKilograms(parseInt(value))
                    temp_fitnessProfile.weight = Math.round(ConvertKilogramsToPounds(parseInt(value)))
                }

                break

            case 'sport':
                temp_fitnessProfile.sportId = value
                temp_fitnessProfile.sportName = sports.find(sport => sport.id === value)?.name || ''
                break

            case 'days-of-training':
                temp_fitnessProfile.daysOfTraining = value
                break

            case 'months-of-training':
                temp_fitnessProfile.monthsOfTraining = value
                break

            case 'years-of-training':
                temp_fitnessProfile.yearsOfTraining = value
                break

            default:
                console.error(key + ' is not a valid key')
                break
        }

        // console.log(temp_fitnessProfile)

        setErrorMessage('')
        setFitnessProfile(temp_fitnessProfile)

    }

    const ValidateGroupProfileTypeFormInputs = () => {
        
        setErrorMessage('')

        var allVaild = true

        // console.log(fitnessProfile)

        if (
            typeof fitnessProfile.defaultAverageAge !== 'number' 
            || fitnessProfile.defaultAverageAge < 1
        ){
            setErrorMessage('Please enter a valid average group age')
            allVaild = false
        }

        const validGenders = ['male', 'female', 'other']
        if (validGenders.includes(fitnessProfile.defaultGender) === false) {
            setErrorMessage('Please select a valid default group gender')
            allVaild = false
        }

        const validMeasurementSystems = ['imperial', 'metric']
        if (validMeasurementSystems.includes(fitnessProfile.measurementSystem) === false) {
            setErrorMessage('Please select a valid measurement system')
            allVaild = false
        }

        if (
            typeof fitnessProfile.defaultAverageHeight !== 'number' 
            || fitnessProfile.defaultAverageHeight < 12
        ){
            setErrorMessage('Please enter a valid average group height')
            allVaild = false
        }

        if (
            typeof fitnessProfile.defaultAverageWeight !== 'number' 
            || fitnessProfile.defaultAverageWeight < 1
        ) {
            setErrorMessage('Please enter a valid average group weight')
            allVaild = false
        }

        if (
            typeof fitnessProfile.sportId !== 'number' 
            || fitnessProfile.sportId === 0
            || typeof fitnessProfile.sportName !== 'string'
            || fitnessProfile.sportName.length === 0
        ) {
            setErrorMessage('Please select a valid sport')
            allVaild = false
        }

        if (typeof fitnessProfile.daysOfTraining !== 'number') {
            setErrorMessage('Please enter a valid number of days of training')
            allVaild = false
        }

        if (typeof fitnessProfile.monthsOfTraining !== 'number') {
            setErrorMessage('Please enter a valid number of months of training')
            allVaild = false
        }

        if (typeof fitnessProfile.yearsOfTraining !== 'number') {
            setErrorMessage('Please enter a valid number of years of training')
            allVaild = false
        }

        return allVaild
    }

    const ValidateIndividualProfileTypeFormInputs = () => {

        setErrorMessage('')

        var allVaild = true

        // console.log(fitnessProfile)

        if (
            typeof fitnessProfile.birthday !== 'string' 
            || fitnessProfile.birthday.length === 0
        ){
            setErrorMessage('Please enter a valid birthday')
            allVaild = false
        }

        const validGenders = ['male', 'female', 'other']
        if (validGenders.includes(fitnessProfile.gender) === false) {
            setErrorMessage('Please select a valid biological gender')
            allVaild = false
        }

        const validMeasurementSystems = ['imperial', 'metric']
        if (validMeasurementSystems.includes(fitnessProfile.measurementSystem) === false) {
            setErrorMessage('Please select a valid measurement system')
            allVaild = false
        }

        if (
            typeof fitnessProfile.height !== 'number' 
            || fitnessProfile.height < 12
        ){
            setErrorMessage('Please enter a valid height')
            allVaild = false
        }

        if (
            typeof fitnessProfile.weight !== 'number' 
            || fitnessProfile.weight < 1
        ) {
            setErrorMessage('Please enter a valid weight')
            allVaild = false
        }
        
        if (
            typeof fitnessProfile.sportId !== 'number' 
            || fitnessProfile.sportId === 0
            || typeof fitnessProfile.sportName !== 'string'
            || fitnessProfile.sportName.length === 0
        ) {
            setErrorMessage('Please select a valid sport')
            allVaild = false
        }

        if (typeof fitnessProfile.daysOfTraining !== 'number') {
            setErrorMessage('Please enter a valid number of days of training')
            allVaild = false
        }

        if (typeof fitnessProfile.monthsOfTraining !== 'number') {
            setErrorMessage('Please enter a valid number of months of training')
            allVaild = false
        }

        if (typeof fitnessProfile.yearsOfTraining !== 'number') {
            setErrorMessage('Please enter a valid number of years of training')
            allVaild = false
        }

        return allVaild
    }

    const OnSaveChangesButton = async () => {
        if (profileType === 'group' && ValidateGroupProfileTypeFormInputs()) {

            setSaveChangesLoading(true)

            var jsonBody = {
                groupId: groupId,
                defaultAverageAge: fitnessProfile.defaultAverageAge,
                defaultGender: fitnessProfile.defaultGender,
                defaultAverageHeight: fitnessProfile.defaultAverageHeight,
                defaultAverageWeight: fitnessProfile.defaultAverageWeight,
                measurementSystem: fitnessProfile.measurementSystem,
                sportId: fitnessProfile.sportId,
                sportName: fitnessProfile.sportName,
                daysOfTraining: fitnessProfile.daysOfTraining,
                monthsOfTraining: fitnessProfile.monthsOfTraining,
                yearsOfTraining: fitnessProfile.yearsOfTraining,
            }

            // console.log(jsonBody);

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/group_fitness_profile', jsonBody)

            // console.log(result);

            if (result.data.status === 'failure') {
                console.error(result)
                setSaveChangesLoading(false)
                return
            }

            setSaveChangesLoading(false)

            HideModal()

            window.location.reload()

        }

        if (profileType === 'individual' && ValidateIndividualProfileTypeFormInputs()) {

            setSaveChangesLoading(true)

            var jsonBody = {
                traineeId: userId,
                birthday: fitnessProfile.birthday,
                gender: fitnessProfile.gender,
                measurementSystem: fitnessProfile.measurementSystem,
                height: fitnessProfile.height,
                weight: fitnessProfile.weight,
                sportId: fitnessProfile.sportId,
                sportName: fitnessProfile.sportName,
                daysOfTraining: fitnessProfile.daysOfTraining,
                monthsOfTraining: fitnessProfile.monthsOfTraining,
                yearsOfTraining: fitnessProfile.yearsOfTraining,
            }

            // console.log(jsonBody); return;

            const result = await WhichWeightAPI('CORE', 'POST', '/trainee_fitness_profile', jsonBody)

            if (result.data.status === 'failure') {
                console.error(result)
                setSaveChangesLoading(false)
                return
            }

            if (boilerplateEnabled === 1) {
                await RegenerateActiveProgramVolume(groupId, userId, clientDate)
                await RegenerateActiveProgramIncompleteWorkouts(groupId, userId, clientDate)
            }

            setSaveChangesLoading(false)

            HideModal()

            window.location.reload()

        }
    }

    useEffect(() => { 
        if (modalData.fitnessProfile && sports === null) {
            GetSportsFromBackend() 
        }
    }, [modalData.fitnessProfile])

    // console.log(fitnessProfile)

    if (profileType === 'group') {
        return (
            <>
                <div className="max-h-[75vh] p-1 text-left space-y-4 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                    
                    <p className='text-lg'>Edit Group Fitness Profile</p>
                    
                    {/* Default Average Age */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>Average Group Age</p>

                        <div className='border border-gray-400 rounded-md relative'>
                            <input
                                type="number"
                                name="defaultAverageAge"
                                id="defaultAverageAge"
                                className="w-52 px-4 py-2 rounded-md [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                                placeholder="Enter Here"
                                value={fitnessProfile.defaultAverageAge}
                                onChange={(event) => HandleFitnessProfileChange('defaultAverageAge', parseInt(event.target.value))}
                            />

                            <div className='absolute right-0 top-0 bottom-0 flex items-center pr-3'>
                                <div className='text-gray-600'>years old</div>
                            </div>
                        </div>
                    </div>

                    {/* Default Gender */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>Default Group Biological Gender</p>

                        <div className='border border-gray-400 rounded-md'>
                            <select 
                                id="defaultGender" 
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={fitnessProfile.defaultGender} 
                                onChange={(event) => HandleFitnessProfileChange('defaultGender', event.target.value)} 
                            >
                                <option value={null}>Select an option</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                    </div>

                    {/* Measurement System */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>Measurement System</p>
                        
                        <div className='border border-gray-400 rounded-md'>
                            <select
                                id="measurementSystem"
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={fitnessProfile.measurementSystem}
                                onChange={(event) => HandleFitnessProfileChange('measurement-system', event.target.value)}
                            >
                                <option value="" disabled>Select an option</option>
                                <option value="imperial">Imperial</option>
                                <option value="metric">Metric</option>
                            </select>
                        </div>
                    </div>
                    
                    {/* Default Average Height */}
                    {fitnessProfile.measurementSystem === 'imperial' && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Average Group Height</p>

                            <div className='border border-gray-400 rounded-md'>
                                <select
                                    id="defaultAverageHeightFeet"
                                    className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                    value={Math.floor((parseInt(fitnessProfile.defaultAverageHeight) || 0) / 12)}
                                    onChange={(event) => HandleFitnessProfileChange('defaultAverageHeightFeet', parseInt(event.target.value))}
                                >
                                    <option value={6}>6 feet</option>
                                    <option value={5}>5 feet</option>
                                    <option value={4}>4 feet</option>
                                    <option value={3}>3 feet</option>
                                    <option value={2}>2 feet</option>
                                    <option value={1}>1 feet</option>
                                    <option value={0} disabled>Select feet</option>
                                </select>
                            </div>

                            <div className='border border-gray-400 rounded-md'>
                                <select
                                    id="defaultAverageHeightInches"
                                    className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                    value={(parseInt(fitnessProfile.defaultAverageHeight) || 0) % 12}
                                    onChange={(event) => HandleFitnessProfileChange('defaultAverageHeightInches', parseInt(event.target.value))}
                                >
                                    <option value={11}>11 inches</option>
                                    <option value={10}>10 inches</option>
                                    <option value={9}>9 inches</option>
                                    <option value={8}>8 inches</option>
                                    <option value={7}>7 inches</option>
                                    <option value={6}>6 inches</option>
                                    <option value={5}>5 inches</option>
                                    <option value={4}>4 inches</option>
                                    <option value={3}>3 inches</option>
                                    <option value={2}>2 inches</option>
                                    <option value={1}>1 inches</option>
                                    <option value={0}>0 inches</option>
                                </select>
                            </div>
                        </div>
                    )}

                    {/* Default Average Weight */}
                    {fitnessProfile.measurementSystem === 'imperial' && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Average Group Weight</p>

                            <div className='border border-gray-400 rounded-md relative'>
                                <input
                                    type="number"
                                    name="defaultAverageWeight"
                                    id="defaultAverageWeight"
                                    className="w-52 px-4 py-2 rounded-md [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                                    placeholder="Enter Here"
                                    value={fitnessProfile.defaultAverageWeight}
                                    onChange={(event) => HandleFitnessProfileChange('defaultAverageWeight', parseInt(event.target.value))}
                                />

                                <div className='absolute right-0 top-0 bottom-0 flex items-center pr-3'>
                                    <div className='text-gray-600'>lbs</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Default Average Height (Metric) */}
                    {fitnessProfile.measurementSystem === 'metric' && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Average Group Height</p>

                            <div className='border border-gray-400 rounded-md relative'>
                                <input
                                    type="number"
                                    min={0}
                                    name="defaultAverageHeightCentimeters"
                                    id="defaultAverageHeightCentimeters"
                                    className="w-52 px-4 py-2 rounded-md [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                                    placeholder="Enter Here"
                                    value={defaultAverageHeightCentimeters}
                                    onChange={(event) => HandleFitnessProfileChange('defaultAverageHeightCentimeters', parseInt(event.target.value))}
                                />

                                <div className='absolute right-0 top-0 bottom-0 flex items-center pr-3'>
                                    <div className='text-gray-600'>cm</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Default Average Weight (Metric) */}
                    {fitnessProfile.measurementSystem === 'metric' && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Average Group Weight</p>

                            <div className='border border-gray-400 rounded-md relative'>
                                <input
                                    type="number"
                                    name="defaultAverageWeight"
                                    id="defaultAverageWeight"
                                    className="w-52 px-4 py-2 rounded-md [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                                    placeholder="Enter Here"
                                    value={defaultAverageWeightKilograms}
                                    onChange={(event) => HandleFitnessProfileChange('defaultAverageWeight', parseInt(event.target.value))}
                                />

                                <div className='absolute right-0 top-0 bottom-0 flex items-center pr-3'>
                                    <div className='text-gray-600'>kgs</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Sport Loading Animation */}
                    {sports === null && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Sport</p>

                            <div className='w-52 h-10 bg-gray-200 animate-pulse rounded-md'></div>
                        </div>
                    )}

                    {/* Sport */}
                    {sports !== null && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Sport</p>

                            <div className='border border-gray-400 rounded-md'>
                                <select
                                    id="sport"
                                    className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                    value={fitnessProfile.sportId}
                                    onChange={(event) => HandleFitnessProfileChange('sport', parseInt(event.target.value))}
                                >
                                    {sports.map((sport, index) => (
                                        <option 
                                            key={index} 
                                            value={parseInt(sport.id)}
                                        >
                                            {sport.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}

                    {/* Days of Training */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>How many <b>days</b> a week does this group strength train?</p>

                        <div className='border border-gray-400 rounded-md'>
                            <select
                                id="daysOfTraining"
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={parseInt(fitnessProfile.daysOfTraining)}
                                onChange={(event) => HandleFitnessProfileChange('days-of-training', parseInt(event.target.value))}
                            >
                                <option value={0}>I don't do strength training</option>
                                <option value={1}>1 day a week</option>
                                <option value={2}>2 days a week</option>
                                <option value={3}>3 days a week</option>
                                <option value={4}>4+ days a week</option>
                            </select>
                        </div>
                    </div>

                    {/* Months of Training */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>How many <b>months in a row</b> has this group strength trained?</p>

                        <div className='border border-gray-400 rounded-md'>
                            <select
                                id="monthsOfTraining"
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={parseInt(fitnessProfile.monthsOfTraining)}
                                onChange={(event) => HandleFitnessProfileChange('months-of-training', parseInt(event.target.value))}
                            >
                                <option value={0}>I don't do consistent strength training</option>
                                <option value={1}>1 month</option>
                                <option value={2}>2 months</option>
                                <option value={3}>3 months</option>
                                <option value={4}>4 months</option>
                                <option value={5}>5 months</option>
                                <option value={6}>6 months</option>
                                <option value={7}>7 months</option>
                                <option value={8}>8 months</option>
                                <option value={9}>9 months</option>
                                <option value={10}>10 months</option>
                                <option value={11}>11 months</option>
                                <option value={12}>12 months</option>
                            </select>
                        </div>
                    </div>

                    {/* Years of Training */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>How many <b>years in a row</b> has this group strength trained?</p>

                        <div className='border border-gray-400 rounded-md'>
                            <select
                                id="yearsOfTraining"
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={parseInt(fitnessProfile.yearsOfTraining)}
                                onChange={(event) => HandleFitnessProfileChange('years-of-training', parseInt(event.target.value))}
                            >
                                <option value={0}>I don't do consistent strength training</option>
                                <option value={1}>1 year</option>
                                <option value={2}>2 years</option>
                                <option value={3}>3 years</option>
                                <option value={4}>4 years</option>
                                <option value={5}>5+ years</option>
                            </select>
                        </div>
                    </div>

                    {errorMessage.length > 0 && (
                        <div className='mt-2 text-center text-red-600'>
                            {errorMessage}
                        </div>
                    )}

                    <div className='pt-2'>
                        <BrandColorButton
                            text="Save Changes"
                            action={OnSaveChangesButton}
                            isLoading={saveChangesLoading}
                        />
                    </div>
                </div>
            </>
        )
    }
    
    if (profileType === 'individual') {
        return (
            <>
                <div className="max-h-[75vh] p-1 text-left space-y-4 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

                    <p className='text-xl'>Edit Fitness Profile</p>
                    
                    {/* Birthday */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>Birthday</p>

                        <div className='border border-gray-400 rounded-md'>
                            <input
                                type="date"
                                name="birthday"
                                id="birthday"
                                className="w-52 px-4 py-2 rounded-md"
                                placeholder="Birthday*"
                                value={fitnessProfile.birthday}
                                onChange={(event) => HandleFitnessProfileChange('birthday', event.target.value)}
                            />
                        </div>
                    </div>

                    {/* Biological Gender */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>Biological Gender</p>

                        <div className='border border-gray-400 rounded-md'>
                            <select 
                                id="gender" 
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={fitnessProfile.gender} 
                                onChange={(event) => HandleFitnessProfileChange('gender', event.target.value)} 
                            >
                                <option value={null}>Select an option</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                    </div>

                    {/* Measurement System */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>Measurement System</p>
                        
                        <div className='border border-gray-400 rounded-md'>
                            <select
                                id="measurementSystem"
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={fitnessProfile.measurementSystem}
                                onChange={(event) => HandleFitnessProfileChange('measurement-system', event.target.value)}
                            >
                                <option value="" disabled>Select an option</option>
                                <option value="imperial">Imperial</option>
                                <option value="metric">Metric</option>
                            </select>
                        </div>
                    </div>
                    
                    {/* Height (Imperial) */}
                    {fitnessProfile.measurementSystem === 'imperial' && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Height</p>

                            <div className='border border-gray-400 rounded-md'>
                                <select
                                    id="heightFeet"
                                    className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                    value={Math.floor((parseInt(fitnessProfile.height) || 0) / 12)}
                                    onChange={(event) => HandleFitnessProfileChange('height-feet', parseInt(event.target.value))}
                                >
                                    <option value={6}>6 feet</option>
                                    <option value={5}>5 feet</option>
                                    <option value={4}>4 feet</option>
                                    <option value={3}>3 feet</option>
                                    <option value={2}>2 feet</option>
                                    <option value={1}>1 feet</option>
                                    <option value={0} disabled>Select feet</option>
                                </select>
                            </div>

                            <div className='border border-gray-400 rounded-md'>
                                <select
                                    id="heightInches"
                                    className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                    value={(parseInt(fitnessProfile.height) || 0) % 12}
                                    onChange={(event) => HandleFitnessProfileChange('height-inches', parseInt(event.target.value))}
                                >
                                    <option value={11}>11 inches</option>
                                    <option value={10}>10 inches</option>
                                    <option value={9}>9 inches</option>
                                    <option value={8}>8 inches</option>
                                    <option value={7}>7 inches</option>
                                    <option value={6}>6 inches</option>
                                    <option value={5}>5 inches</option>
                                    <option value={4}>4 inches</option>
                                    <option value={3}>3 inches</option>
                                    <option value={2}>2 inches</option>
                                    <option value={1}>1 inches</option>
                                    <option value={0}>0 inches</option>
                                </select>
                            </div>
                        </div>
                    )}

                    {/* Weight (Imperial) */}
                    {fitnessProfile.measurementSystem === 'imperial' && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Weight</p>

                            <div className='border border-gray-400 rounded-md relative'>
                                <input
                                    type="number"
                                    name="weight"
                                    id="weight"
                                    className="w-52 px-4 py-2 rounded-md [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                                    placeholder="Enter Here"
                                    value={fitnessProfile.weight}
                                    onChange={(event) => HandleFitnessProfileChange('weight', parseInt(event.target.value))}
                                />

                                <div className='absolute right-0 top-0 bottom-0 flex items-center pr-3'>
                                    <div className='text-gray-600'>lbs</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Height (Metric) */}
                    {fitnessProfile.measurementSystem === 'metric' && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Height</p>

                            <div className='border border-gray-400 rounded-md relative'>
                                <input
                                    type="number"
                                    min={0}
                                    name="heightCentimeters"
                                    id="heightCentimeters"
                                    className="w-52 px-4 py-2 rounded-md [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                                    placeholder="Enter Here"
                                    value={heightCentimeters}
                                    onChange={(event) => HandleFitnessProfileChange('height-centimeters', parseInt(event.target.value))}
                                />

                                <div className='absolute right-0 top-0 bottom-0 flex items-center pr-3'>
                                    <div className='text-gray-600'>cm</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Weight (Metric) */}
                    {fitnessProfile.measurementSystem === 'metric' && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Weight</p>

                            <div className='border border-gray-400 rounded-md relative'>
                                <input
                                    type="number"
                                    name="weight"
                                    id="weight"
                                    className="w-52 px-4 py-2 rounded-md [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                                    placeholder="Enter Here"
                                    value={weightKilograms}
                                    onChange={(event) => HandleFitnessProfileChange('weight', parseInt(event.target.value))}
                                />

                                <div className='absolute right-0 top-0 bottom-0 flex items-center pr-3'>
                                    <div className='text-gray-600'>kgs</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Sport Loading Animation */}
                    {sports === null && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Sport</p>

                            <div className='w-52 h-10 bg-gray-200 animate-pulse rounded-md'></div>
                        </div>
                    )}

                    {/* Sport */}
                    {sports !== null && (
                        <div className='flex items-center gap-x-4'>
                            <p className='flex-grow'>Sport</p>

                            <div className='border border-gray-400 rounded-md'>
                                <select
                                    id="sport"
                                    className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                    value={fitnessProfile.sportId}
                                    onChange={(event) => HandleFitnessProfileChange('sport', parseInt(event.target.value))}
                                >
                                    {sports.map((sport, index) => (
                                        <option 
                                            key={index} 
                                            value={parseInt(sport.id)}
                                        >
                                            {sport.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}

                    {/* Days of Training */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>How many <b>days</b> a week does this athlete strength train?</p>

                        <div className='border border-gray-400 rounded-md'>
                            <select
                                id="daysOfTraining"
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={parseInt(fitnessProfile.daysOfTraining)}
                                onChange={(event) => HandleFitnessProfileChange('days-of-training', parseInt(event.target.value))}
                            >
                                <option value={0}>I don't do strength training</option>
                                <option value={1}>1 day a week</option>
                                <option value={2}>2 days a week</option>
                                <option value={3}>3 days a week</option>
                                <option value={4}>4+ days a week</option>
                            </select>
                        </div>
                    </div>

                    {/* Months of Training */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>How many <b>months in a row</b> has this athlete strength trained?</p>

                        <div className='border border-gray-400 rounded-md'>
                            <select
                                id="monthsOfTraining"
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={parseInt(fitnessProfile.monthsOfTraining)}
                                onChange={(event) => HandleFitnessProfileChange('months-of-training', parseInt(event.target.value))}
                            >
                                <option value={0}>I don't do consistent strength training</option>
                                <option value={1}>1 month</option>
                                <option value={2}>2 months</option>
                                <option value={3}>3 months</option>
                                <option value={4}>4 months</option>
                                <option value={5}>5 months</option>
                                <option value={6}>6 months</option>
                                <option value={7}>7 months</option>
                                <option value={8}>8 months</option>
                                <option value={9}>9 months</option>
                                <option value={10}>10 months</option>
                                <option value={11}>11 months</option>
                                <option value={12}>12 months</option>
                            </select>
                        </div>
                    </div>

                    {/* Years of Training */}
                    <div className='flex items-center gap-x-4'>
                        <p className='flex-grow'>How many <b>years in a row</b> has this athlete strength trained?</p>

                        <div className='border border-gray-400 rounded-md'>
                            <select
                                id="yearsOfTraining"
                                className="w-52 px-4 py-2 rounded-md border-white border-r-[16px]"
                                value={parseInt(fitnessProfile.yearsOfTraining)}
                                onChange={(event) => HandleFitnessProfileChange('years-of-training', parseInt(event.target.value))}
                            >
                                <option value={0}>I don't do consistent strength training</option>
                                <option value={1}>1 year</option>
                                <option value={2}>2 years</option>
                                <option value={3}>3 years</option>
                                <option value={4}>4 years</option>
                                <option value={5}>5+ years</option>
                            </select>
                        </div>
                    </div>

                    {errorMessage.length > 0 && (
                        <div className='mt-2 text-center text-red-600'>
                            {errorMessage}
                        </div>
                    )}
                </div>

                <div className='pt-2'>
                    <BrandColorButton
                        text="Save Changes"
                        action={OnSaveChangesButton}
                        isLoading={saveChangesLoading}
                    />
                </div>
            </>
        )
    }
}
